import { useMutation, useQueryClient } from '../../lib';
import { useTribeClient } from '../../useTribeClient';
import { getFeedKey, getPostKey, getPostsKey } from '../../utils/keys';
import { getPostsQueryById } from './filters';
export const useUpdatePost = (options) => {
    const { useMutationOptions, fields = 'default' } = options || {};
    const { client } = useTribeClient();
    const queryClient = useQueryClient();
    return useMutation((input) => client.posts.update(input, fields), {
        onMutate: async (newPost) => {
            const postKey = getPostKey({ variables: { id: newPost === null || newPost === void 0 ? void 0 : newPost.id } });
            await queryClient.cancelQueries(postKey);
            const snapshot = queryClient.getQueryData(postKey);
            queryClient.setQueriesData(postKey, old => ({
                ...old,
                ...newPost,
            }));
            return { snapshot };
        },
        onSuccess: updatedPost => {
            const postKey = getPostKey({ variables: { id: updatedPost === null || updatedPost === void 0 ? void 0 : updatedPost.id } });
            queryClient.setQueriesData(postKey, oldPost => ({
                ...oldPost,
                ...updatedPost,
            }));
        },
        onError: (err, newPost, context) => {
            const postKey = getPostKey({ variables: { id: newPost.id } });
            if (context.snapshot)
                queryClient.setQueriesData(postKey, context.snapshot);
            queryClient.invalidateQueries(postKey);
        },
        onSettled: data => {
            const parentPostId = data === null || data === void 0 ? void 0 : data.repliedToId;
            const postKey = getPostKey();
            queryClient.invalidateQueries(postKey);
            const postsKey = getPostsKey();
            queryClient.invalidateQueries(postsKey);
            const feedKey = getFeedKey();
            queryClient.invalidateQueries(feedKey);
            // we want to "refetch" only replies query if any
            // (invalidate does not work for disabled queries)
            // (replies withing a reply is a disabled query)
            if (parentPostId) {
                queryClient.refetchQueries(getPostsQueryById(parentPostId));
            }
        },
        ...useMutationOptions,
    });
};
//# sourceMappingURL=useUpdatePost.js.map